import { Grid, Heading, Text } from '@simplywallst/ui-core';

export const TableTitle = ({
  itemCount,
  title,
}: {
  itemCount: number;
  title: string;
}) => {
  return (
    <Grid templateColumns="auto 24px" gap="8px" alignItems="center">
      <Heading as="h2" typography="baseStrong">
        {title}
      </Heading>
      <Grid
        backgroundColor="phantom"
        width="24px"
        height="24px"
        placeContent="center"
        borderRadius="x12"
      >
        <Text typography="xSmallStrong" color="textSoft">
          {itemCount}
        </Text>
      </Grid>
    </Grid>
  );
};
